import Head from "next/head";
import { FC } from "react";
import {
  DEFAULT_OG_IMAGE,
  SITE_NAME,
  toAbsoluteUrl,
} from "src/utils/seo";

function addItemArrayByCamma(arr: []) {
  let result = "";
  for (let i = 0; i < arr.length; i++) {
    result += `${arr[i]}${arr.length - 1 === i ? "" : ","}`;
  }
  return result;
}

type Props = {
  title: string;
  keyword: string[] | [];
  seoDescription: string;
  canonical: string;
  image?: string | null;
  noIndex?: boolean;
};

const SEOHEAD: FC<Props> = ({
  title,
  keyword,
  seoDescription,
  canonical,
  image = null,
  noIndex = false,
}) => {
  const absoluteUrl = toAbsoluteUrl(canonical);
  const ogImage = image ? toAbsoluteUrl(image) : DEFAULT_OG_IMAGE;

  return (
    <Head>
      <meta charSet="utf-8" />
      <title>{title ?? SITE_NAME}</title>
      <meta
        name="apple-mobile-web-app-title"
        content={title ?? SITE_NAME}
      />
      <meta
        name="description"
        content={seoDescription ?? SITE_NAME}
      />
      <meta
        name="keywords"
        content={addItemArrayByCamma(keyword ?? []) || "دادبانان, آموزش حقوقی"}
      />
      <meta
        name="robots"
        content={noIndex ? "noindex, nofollow" : "index, follow"}
      />
      <link rel="canonical" href={absoluteUrl} />
      <meta property="og:locale" content="fa_IR" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title ?? SITE_NAME} />
      <meta content={seoDescription} property="og:description" />
      <meta property="og:url" content={absoluteUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="834" />
      <meta property="og:image:height" content="417" />
      <meta property="og:image:type" content="image/png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title ?? SITE_NAME} />
      <meta
        name="twitter:description"
        content={
          title && seoDescription ? `${title}. ${seoDescription}` : "دادبانان"
        }
      />
      <meta property="twitter:image" content={ogImage} />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="twitter:domain" content="dadbanan.com" />
      <meta name="enamad" content="32013660" />
      <script
        dangerouslySetInnerHTML={{
          __html: `!function (t, e, n) {
            t.yektanetAnalyticsObject = n, t[n] = t[n] || function () {
                t[n].q.push(arguments)
            }, t[n].q = t[n].q || [];
            var a = new Date, r = a.getFullYear().toString() + "0" + a.getMonth() + "0" + a.getDate() + "0" + a.getHours(),
                c = e.getElementsByTagName("script")[0], s = e.createElement("script");
            s.id = "ua-script-yIgsoYR4"; s.dataset.analyticsobject = n;
            s.async = 1; s.type = "text/javascript";
            s.src = "https://cdn.yektanet.com/rg_woebegone/scripts_v3/yIgsoYR4/rg.complete.js?v=" + r, c.parentNode.insertBefore(s, c)
        }(window, document, "yektanet");`,
        }}
      ></script>
    </Head>
  );
};
export default SEOHEAD;
